/**
 * Convert a string to a URL-friendly slug.
 * "Taj Mahal" → "taj-mahal"
 * "Istanbul, Turkey" → "istanbul-turkey"
 * "Zürich" → "zurich"
 */
export default function slugify(text) {
  if (!text || typeof text !== 'string') return '';
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}
